<template>
  <Bread-crumb page="Beranda > Data Foto > Lihat Data Foto"></Bread-crumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Data Foto</h3>
        <div class="card">
          <DataTable ref="dt"
                     :value="dataAnak"
                     v-model:selection="selectedTemplate"
                     v-model:filters="filters"
                     :loading="loading"
                     :paginator="true"
                     :rows="10"
                     paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                     :rowsPerPageOptions="[5,10,25]"
                     currentPageReportTemplate="Tampil {first} dari {last} of {totalRecords} data periode"
                     class="p-datatable-sm"
                     stripedRows
          >
            <template #paginatorend>
            </template>
            <template #header>
              <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                    </span>
              </div>
            </template>
            <template #empty> Tidak ada data. </template>
            <template #loading> Mengambil data. Silakan tunggu. </template>
            <Column field="anak_nama" header="Nama Anak" sortable style="min-width:12rem"></Column>
            <Column field="ortu_nama" header="Nama Ortu" sortable style="min-width:12rem"></Column>
            <Column field="anak_nik" header="NIK Anak" sortable style="min-width:12rem"></Column>
            <Column field="inv_child" header="Inv ID" sortable style="min-width:12rem"></Column>
            <Column field="keputusanpsb" header="Keputusan" sortable style="min-width:12rem;text-transform: uppercase;"></Column>
            <Column header="Photo">
              <template #body="item">
                <img class="foto-jadul"
                    :src="item.data.imageurl"
                    :alt="item.data.nama_file"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {FilterMatchMode} from "@primevue/core/api";
import DashboardServices from "@/services/dashboard.services";
import InputText from "primevue/inputtext";
export default {
  name: "DataFoto",
  components:{BreadCrumb,DataTable,Column,InputText},
  data:()=>({
    loading: false,
    response: '',
    message:'',
    success:false,
    dataAnak:[],
    selectedTemplate:[],
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      'inv_child': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'anak_nama': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'ortu_nama': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'keputusanpsb': {value: '', matchMode: FilterMatchMode.CONTAINS},
    },
  }),
  methods:{
    getDataAnak(){
      this.loading = true;
      let data = {};
      let path = '/dashboard/getDataFoto';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAnak = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  },mounted() {
    this.getDataAnak()
  }
}
</script>

<style scoped>

.foto-jadul img {
  width: 180px;
  height: 180px;

  display: block;

  object-fit: cover;

  /* sedikit efek foto lama */
  filter: sepia(0.08) contrast(0.95);

  /* jangan ikut scalloped */
  border-radius: 0;
}

.foto-jadul {
  width: 200px;
  height: 200px;
  padding: 10px;
  box-sizing: border-box;

  background: #f8f3df;

  border-radius: 12px;

  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);

  display: flex;
  align-items: center;
  justify-content: center;
}

</style>